module.exports = __webpack_public_path__ + "75f4a86664bc2f8670b3fea4a71a2c6e.pdf";